import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReceiptDetailService extends DatabaseGwService {

  URL_PATH: string = '/purchase-receipt-details';
}
